import { makeAutoObservable, autorun, runInAction } from 'mobx'
// import env from '@env'
import { restaurantConfig } from '@mobx/mall'
// import initFeeClient from 'fee-client'

class Tip {
  constructor () {
    makeAutoObservable(this, {
      storeId: false
    })
  }
  storeId?: number
  // feeClient?: any
  tipOptions: TTipOption[] = []

  async init (storeId: number, force?: boolean) {
    if (storeId === this.storeId && !force) {
      return
    }
    this.storeId = storeId
  }

  loadOptions (eatType: TEatType, subtotal: number, tax: number) {
    const feeClient = restaurantConfig.fee
    if (!feeClient) return

    const diningOptionMap = {
      'mall': 'mall'
    }

    const diningOption = diningOptionMap[eatType] || 'mall'
    const params = {
      diningOption,
      clientType: 'Mobile',
      total: subtotal,
      tax,
    }

    // console.debug('tip options params', params)
    const options: TTipOption[] = feeClient.tip(params)
    // console.debug('tip options', options)

    runInAction(() => {
      this.tipOptions = options
    })
    return options
  }
}

const tipMobx = new Tip()

autorun(async () => {
  tipMobx.init(0)
})

export default tipMobx
